import { useTranslation } from 'react-i18next';
import type { UserCompanyGroupDto } from '@monorepo/shared';
import { DiffuseGroupOption } from './DiffuseGroupOption';

interface DiffuseGroupsListProps {
  groups: UserCompanyGroupDto[];
  isLoadingGroups: boolean;
  selectedGroupIds: string[];
  canManageGroups: boolean;
  onToggle: (groupId: string) => void;
  onOpenGroup: (groupId: string) => void;
  onCreateGroups: () => void;
}

export const DiffuseGroupsList = ({
  groups,
  isLoadingGroups,
  selectedGroupIds,
  canManageGroups,
  onToggle,
  onOpenGroup,
  onCreateGroups,
}: DiffuseGroupsListProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 min-h-0 flex-col">
      <label className="block flex-shrink-0 text-sm font-medium text-gray-700 mb-3">
        {t('documents.diffuse_modal.groups.label')}
      </label>
      <p className="flex-shrink-0 text-sm text-gray-500 mb-4">
        {t('documents.diffuse_modal.groups.description')}
      </p>

      {isLoadingGroups ? (
        <div className="text-center py-4 text-gray-500">{t('common.loading')}</div>
      ) : groups.length === 0 ? (
        <div className="flex flex-col items-center gap-3 py-4 text-gray-500">
          <p>{t('documents.diffuse_modal.groups.empty')}</p>
          {canManageGroups && (
            <button
              type="button"
              onClick={onCreateGroups}
              className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition"
            >
              {t('documents.diffuse_modal.groups.create_groups_link')}
            </button>
          )}
        </div>
      ) : (
        <div className="flex-1 min-h-0 space-y-3 overflow-y-auto">
          {groups.map((group) => (
            <DiffuseGroupOption
              key={group.id}
              group={group}
              isSelected={selectedGroupIds.includes(group.id)}
              onToggle={onToggle}
              onOpenGroup={onOpenGroup}
            />
          ))}
        </div>
      )}
    </div>
  );
};
